import React, { useState } from "react";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import Button from "@/main/components/shared/button/button";
import { getTranslateByKey } from "@/main/services/utils";
import * as S from "./styles";
import KogAutoCompleteControlled from "../../../inputAutoComplete/autoCompleteControlled";
import KogInputTextControlledNew from "../../../inputText/inputTextControlledNew";
import { useReasonReducer } from "@/main/store/reason";
import { convertStringForBoolean } from "@/main/services/utilsString";
import { Control, UseFormSetValue, useFormState } from "react-hook-form";
import { BuyerPartForms } from "../modalBuyerManualAnswer/modalManualAnswerUtils";
import { KeyValueDefault } from "@/main/models/common";

interface IModalConfirmBuyerManualAnswerProps {
	openModalConfirm: boolean;
	setOpenModalConfirm: React.Dispatch<React.SetStateAction<boolean>>;
	callbackComfirm: () => Promise<boolean>;
	setValue: UseFormSetValue<BuyerPartForms>;
	control: Control<BuyerPartForms, any>;
	watcherReasonType: KeyValueDefault | null;
	diabledConfirm?: boolean;
}

function ModalConfirmBuyerManualAnswer({
	setOpenModalConfirm,
	callbackComfirm,
	setValue,
	control,
	watcherReasonType,
}: IModalConfirmBuyerManualAnswerProps) {
	const { reason: reasonReducer } = useReasonReducer();

	const [isLoadingSave, setIsLoadingSave] = useState<boolean>(false);

	async function onClickActionConfirm() {
		setIsLoadingSave(true);
		try {
			const success = await callbackComfirm();
			if (success) {
				setOpenModalConfirm(false);
			}
		} catch (error) {
			console.error(error);
		} finally {
			setIsLoadingSave(false);
		}
	}

	const renderMessageConfirmationCancel = () => {
		return (
			<S.AreaMessageConfirmation>
				<p>{getTranslateByKey("information.confirmSave")}</p>
			</S.AreaMessageConfirmation>
		);
	};

	const reasonRequiresComplement = convertStringForBoolean(watcherReasonType?.default);

	return (
		<S.ContainerModalConfirmation>
			<h6>{renderMessageConfirmationCancel()}</h6>

			<KogAutoCompleteControlled
				id="id-directAssign-select-reason"
				nameCustom="reason"
				variant="outlined"
				isDefaultValueUnique
				label={getTranslateByKey("information.reason")}
				control={control}
				rulesCustom={{ required: true }}
				setValueCustom={setValue}
				options={reasonReducer.data}
				isLoading={reasonReducer.isLoading}
				onChangeCustom={(option) => {
					if (option === null) return;

					if (convertStringForBoolean((option as KeyValueDefault)?.default)) {
						setValue("reasonComplement", "");
					}
				}}
				className="customBorder"
			/>
			{reasonRequiresComplement && (
				<KogInputTextControlledNew
					id="id-directAssign-input-reasonComplement"
					label={getTranslateByKey("information.description")}
					name="reasonComplement"
					variant="outlined"
					required={true}
					control={control}
					className="customBorder"
				/>
			)}

			<div
				style={{
					display: "flex",
					justifyContent: "center",
					gap: "1rem",
				}}
			>
				<SecondaryButton
					type="button"
					disabled={isLoadingSave}
					onClick={() => {
						setOpenModalConfirm(false);
					}}
					id="id-createOrder-button-no"
				>
					{getTranslateByKey("information.no")}
				</SecondaryButton>
				<Button
					id="id-createOrder-button-yes"
					type="button"
					isLoading={isLoadingSave}
					disabled={false}
					onClick={() => onClickActionConfirm()}
				>
					{getTranslateByKey("information.yes")}
				</Button>
			</div>
		</S.ContainerModalConfirmation>
	);
}

function WrapperModalConfirmBuyerManualAnswer(props: IModalConfirmBuyerManualAnswerProps) {
	const { isValid } = useFormState({ control: props.control });
	return (
		<KogModalFadeComponent isInModal open={props.openModalConfirm} setOpen={props.setOpenModalConfirm}>
			{props.openModalConfirm ? <ModalConfirmBuyerManualAnswer {...props} diabledConfirm={!isValid} /> : <div />}
		</KogModalFadeComponent>
	);
}
export default WrapperModalConfirmBuyerManualAnswer;
